/** Query key 工厂，集中定义避免拼写漂移（见 design/04-frontend.md）。 */

import type { NotificationFilter, ReportStatus, SearchType, TimelineKind, UserTab } from './types'

export const keys = {
  me: () => ['me'] as const,

  user: (username: string) => ['user', username] as const,
  userFollowers: (username: string) => ['user', username, 'followers'] as const,
  userFollowing: (username: string) => ['user', username, 'following'] as const,
  suggestions: () => ['users', 'suggestions'] as const,
  trends: () => ['trends'] as const,
  apiKeys: () => ['agent', 'keys'] as const,
  sessions: () => ['auth', 'sessions'] as const,
  twoFactor: () => ['auth', '2fa'] as const,
  preferences: () => ['settings', 'preferences'] as const,
  mutedWords: () => ['settings', 'muted-words'] as const,
  dataExport: () => ['settings', 'export'] as const,

  timelineRoot: () => ['timeline'] as const,
  timelineHome: (kind: TimelineKind = 'all') => ['timeline', 'home', kind] as const,
  timelineExplore: (kind: TimelineKind = 'all') => ['timeline', 'explore', kind] as const,
  timelineForYou: (kind: TimelineKind = 'all') => ['timeline', 'foryou', kind] as const,
  timelineUser: (username: string, tab: UserTab) => ['timeline', 'user', username, tab] as const,

  blocks: () => ['relations', 'blocks'] as const,
  followRequests: () => ['relations', 'follow-requests'] as const,
  mutes: () => ['relations', 'mutes'] as const,

  notificationsRoot: () => ['notifications'] as const,
  notifications: (filter: NotificationFilter = 'all') => ['notifications', 'list', filter] as const,
  unreadCount: () => ['notifications', 'unread'] as const,

  /** 书签列表放在 timeline 前缀下，乐观更新的缓存遍历才能覆盖到它 */
  bookmarks: () => ['timeline', 'bookmarks'] as const,
  timelineHashtag: (name: string, kind: TimelineKind = 'all') =>
    ['timeline', 'hashtag', name, kind] as const,

  /** 列表的元信息与成员；时间线放在 timeline 前缀下，和书签同一个理由 */
  listsRoot: () => ['lists'] as const,
  /** 不带 member 的是带 member 的前缀：作废「我的列表」时「添加到列表」对话框一起刷新 */
  listsMine: (member?: string) =>
    member ? (['lists', 'mine', member] as const) : (['lists', 'mine'] as const),
  list: (id: string) => ['lists', 'detail', id] as const,
  listMembers: (id: string) => ['lists', 'members', id] as const,
  timelineList: (id: string, kind: TimelineKind = 'all') => ['timeline', 'list', id, kind] as const,

  searchRoot: () => ['search'] as const,
  search: (q: string, type: SearchType) => ['search', type, q] as const,
  typeahead: (q: string) => ['search', 'typeahead', q] as const,

  post: (id: string) => ['post', id] as const,
  postThread: (id: string) => ['post', id, 'thread'] as const,
  postReplies: (id: string) => ['post', id, 'replies'] as const,
  postLikes: (id: string) => ['post', id, 'likes'] as const,
  postReposts: (id: string) => ['post', id, 'reposts'] as const,

  conversationsRoot: () => ['conversations'] as const,
  conversations: () => ['conversations', 'list'] as const,
  conversation: (id: string) => ['conversations', 'detail', id] as const,
  conversationMessages: (id: string) => ['conversations', 'messages', id] as const,
  dmUnread: () => ['conversations', 'unread'] as const,

  adminRoot: () => ['admin'] as const,
  adminReports: (status: ReportStatus) => ['admin', 'reports', status] as const,
  adminActions: () => ['admin', 'actions'] as const,
}
